export var KycTypes;
(function (KycTypes) {
    let KycSteps;
    (function (KycSteps) {
        // this is the order in which the kyc modals appear
        KycSteps["KYC_1"] = "IncompleteKYC";
        KycSteps["KYC_2"] = "PersonalDetails";
        KycSteps["KYC_3"] = "ResidentialDetails";
        KycSteps["KYC_4"] = "SourceOfFunds";
        KycSteps["KYC_5"] = "IdDetails1";
        KycSteps["KYC_6"] = "SelectIdCard";
        KycSteps["KYC_7"] = "IDDetails2";
        KycSteps["KYC_8"] = "SubmitDocs";
        KycSteps["VERIFICATION_STATUS"] = "VerificationStatus";
        KycSteps["BLOCKED"] = "BlockedStatus";
        KycSteps["COMPLETE"] = "CompleteStatus";
    })(KycSteps = KycTypes.KycSteps || (KycTypes.KycSteps = {}));
    let KycStatus;
    (function (KycStatus) {
        KycStatus["APPROVED"] = "Approved";
        KycStatus["UNDER_REVIEW"] = "UnderReview";
        KycStatus["INCOMPLETE"] = "Incomplete";
        KycStatus["REJECTED"] = "Rejected";
        KycStatus["BLOCKED"] = "Blocked";
        KycStatus["PENDING_COMPLIANCE"] = "PendingCompliance";
    })(KycStatus = KycTypes.KycStatus || (KycTypes.KycStatus = {}));
    KycTypes.FundsMapping = {
        winnings: 'Winnings',
        inheritance: 'Inheritance',
        business_income: 'Proceeds from business transactions',
        savings: 'Savings',
        salary: 'Salary',
    };
    let DocType;
    (function (DocType) {
        DocType[DocType["SELFIE"] = 0] = "SELFIE";
        DocType[DocType["ID_CARD"] = 1] = "ID_CARD";
        DocType[DocType["SELFIE_BASE64"] = 2] = "SELFIE_BASE64";
        DocType[DocType["ID_CARD_BASE64"] = 3] = "ID_CARD_BASE64";
        DocType[DocType["LIVENESS"] = 4] = "LIVENESS";
        DocType[DocType["ID_BACK"] = 5] = "ID_BACK";
        DocType[DocType["LIVENESS_BASE64"] = 6] = "LIVENESS_BASE64";
        DocType[DocType["ID_BACK_BASE64"] = 7] = "ID_BACK_BASE64";
    })(DocType = KycTypes.DocType || (KycTypes.DocType = {}));
    let SmileDocTypes;
    (function (SmileDocTypes) {
        SmileDocTypes["SELFIE"] = "SELFIE";
        SmileDocTypes["ID_CARD"] = "ID_CARD";
        SmileDocTypes["SELFIE_BASE64"] = "SELFIE_BASE64";
        SmileDocTypes["ID_CARD_BASE64"] = "ID_CARD_BASE64";
        SmileDocTypes["LIVENESS"] = "LIVENESS";
        SmileDocTypes["ID_BACK"] = "ID_BACK";
        SmileDocTypes["LIVENESS_BASE64"] = "LIVENESS_BASE64";
        SmileDocTypes["ID_BACK_BASE64"] = "ID_BACK_BASE64";
    })(SmileDocTypes = KycTypes.SmileDocTypes || (KycTypes.SmileDocTypes = {}));
    KycTypes.docType = {
        [DocType.SELFIE]: 'SELFIE',
        [DocType.ID_CARD]: 'ID_CARD',
        [DocType.SELFIE_BASE64]: 'SELFIE_BASE64',
        [DocType.ID_CARD_BASE64]: 'ID_CARD_BASE64',
        [DocType.LIVENESS]: 'LIVENESS',
        [DocType.ID_BACK]: 'ID_BACK',
        [DocType.LIVENESS_BASE64]: 'LIVENESS_BASE64',
        [DocType.ID_BACK_BASE64]: 'ID_BACK_BASE64',
    };
})(KycTypes || (KycTypes = {}));
